export default {
      id: "oc-open-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "sprite.svg#oc-open",
      toString: function () {
        return this.url;
      }
    }